import http from './http';
import serviceHelper from './serviceHelper';

export const getFaqs = async () => {
  return serviceHelper(http.get('/faq'), false);
};
